import { Modal } from 'antd';
import styled from 'styled-components';

export const CustomModalWrapper = styled(Modal)`
  .ant-modal-title {
    font-size: 1.25rem;
  }
`;
